/*
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-04-02 13:42:33
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-02 14:36:18
 */
import request from '@/utils/request'
// 列表
const list = '/rest/base/service-case/page'
// 新增
const add = '/rest/base/service-case/save'
// 项目部
const dept = '/rest/base/project-dept/list'

/**
 * @description: 列表
 * @param        {object} params 请求接口参数：pageNo='页码'，pageSize='每页条数'
 * @return       {object} res
 */
export async function getCaselist (params) {
  return request.get(list, {
    ...params,
  })
}

/**
 * @description: 获取项目部
 * @return       {object} res
 */
export async function getDeptlist (params) {
  return request.get(dept)
}

/**
 * @description: 获取项目部
 * @return       {object} res
 */
export async function getCaseDetailData (params) {
  return request.get(`/rest/base/service-case/${params}/detail`, {
    ...params,
  })
}

/**
 * @description: 新增
 * @param        {object} 请求接口参数：name='案件名称'projectDeptId='项目部id'
 * @return       {object} res
 */
export async function caseSave (params) {
  return request.post(add, {
    ...params,
  }, {}, 2)
}

/**
 * @description: 更新
 * @param        {object} 请求接口参数：name='名称'projectDeptId='项目部主键' id='服务案件主键'
 * @return       {object} res
 */
export async function updateCase (params) {
  return request.post(`/rest/base/service-case/${params.id}/update`, {
    ...params,
  }, {}, 2)
}

/**
 * @description: 删除
 * @param        {object} params id='案件'
 * @return       {object} res
 */
export async function deleteCase (params) {
  return request.post(`/rest/base/service-case/${params}/del`, {
    ...params,
  })
}
